import { i18n } from "@bebit/store";
import { DateRange, DatePickerPreset } from "@bebit/types";
import { startOfDay, endOfDay, subDays, format } from "date-fns";

export const DATE_PERIOD_FORMAT = {
  url: "yyyyMMdd",
  ui: "yyyy/M/d",
  api: "yyyy-MM-dd",
};

export function getDefaultPeriod(): DateRange {
  const today = new Date();
  return {
    start: startOfDay(subDays(today, 29)),
    end: endOfDay(subDays(today, 2)),
  };
}

export function isHighlightablePreset(preset: DatePickerPreset | undefined): boolean {
  return preset === DatePickerPreset.Last28Days || preset === DatePickerPreset.Last7Days;
}

export function toPeriodInPanel(period: DateRange, preset: DatePickerPreset | undefined): string {
  const formattedStartDate = format(period.start, DATE_PERIOD_FORMAT.ui);
  const formattedEndDate = format(period.end, DATE_PERIOD_FORMAT.ui);

  if (preset === DatePickerPreset.Last7Days)
    return `${i18n.global.t("utils.period.Last7Days")} (${formattedStartDate} - ${formattedEndDate})`;
  if (preset === DatePickerPreset.Last28Days)
    return `${i18n.global.t("utils.period.Last28Days")} (${formattedStartDate} - ${formattedEndDate})`;
  return `${formattedStartDate} - ${formattedEndDate}`;
}
